import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitle: {
		id: 'business-list.controllers.update-group-issue.error-title',
		defaultMessage: 'Failed to update {field}',
		description: 'Title in error flag when issue fails to update a specific field eg. assignee',
	},
	errorMessage: {
		id: 'business-list.controllers.update-group-issue.error-message',
		defaultMessage:
			"Something went wrong updating the issue's {field} field. Please try again or contact your administrator if the problem persists.",
		description: 'Message in error flag when issue fails to update a specific field eg. assignee',
	},
});
